// Module
var code = "<div id=\"V-FFAE3468-0E0F-4229-9C93-C921B0378B47\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding content}\" class=\"stretch-content\"></div> </div> ";
// Exports
export default code;